import React, { FC, Fragment, memo, useEffect } from 'react';
import { Account, DesignSettings, Frame, SerializedNodes, useEditor } from '@mnz/builder';
import { StyleSheetManager } from 'styled-components';
import IFrame, { FrameContextConsumer } from 'react-frame-component';
import { Container } from '@mnz/element';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

interface DesignViewProps {
    data: string | SerializedNodes;
    designSettings: DesignSettings;
    account: Account;
    onFrameWindowClick?: () => void;
    framePointerEvents?: string;
    openBlockModal: () => void;
}
const FrameWindow: FC<{ window: any; onFrameWindowClick?: () => void }> = ({ window, onFrameWindowClick }) => {
    useEffect(() => {
        if (onFrameWindowClick) {
            window.addEventListener('click', onFrameWindowClick, { capture: true });
        }
        return () => {
            window.removeEventListener('click', onFrameWindowClick, { capture: true });
        };
    }, [window, onFrameWindowClick]);
    return null;
};

const DesignView: FC<DesignViewProps> = ({
    data,
    designSettings,
    account,
    onFrameWindowClick,
    framePointerEvents = 'initial',
    openBlockModal,
}) => {
    const {
        actions: { setProp },
        nodes,
    } = useEditor((_, query) => {
        const nodes = query.getNodes();
        return {
            nodes,
        };
    });
    useEffect(() => {
        setProp('ROOT', (props: any) => (props.openBlockModal = openBlockModal));
    }, [nodes['ROOT']]);

    return (
        <Fragment>
            <IFrame
                initialContent={`<!DOCTYPE html><html style="pointer-events: ${framePointerEvents}"><head><style>\n::-webkit-scrollbar{\ndisplay:none;\n}\n-ms-overflow-style:none;\nscrollbar-width:none;\n</style></head><body><div class="frame-root"></div></body></html>`}
                style={{
                    width: '100%',
                    height: '100%',
                }}
            >
                <FrameContextConsumer>
                    {({ document, window }) => {
                        return (
                            <StyleSheetManager target={document?.head}>
                                <CacheProvider
                                    value={createCache({
                                        key: 'css',
                                        container: document?.head,
                                        prepend: true,
                                    })}
                                >
                                    <Fragment>
                                        {onFrameWindowClick && (
                                            <FrameWindow window={window} onFrameWindowClick={onFrameWindowClick} />
                                        )}
                                        <Frame
                                            data={
                                                data == '[]'
                                                    ? `{"ROOT":{"type":{"resolvedName":"Document"},"props":{},"displayName":"Document","custom":{},"parent":"","hidden":false,"nodes":[],"linkedNodes":{}}}`
                                                    : data
                                            }
                                            config={{
                                                fontEndpoint: process.env.REACT_APP_FONT_PATH as string,
                                            }}
                                            designSettings={designSettings}
                                            account={account}
                                        >
                                            <Container designSettings={designSettings} account={account}>
                                                {/* <Basic.BasicBasicInfo design={FAKE_DATA.designSetting} /> */}
                                            </Container>
                                        </Frame>
                                    </Fragment>
                                </CacheProvider>
                            </StyleSheetManager>
                        );
                    }}
                </FrameContextConsumer>
            </IFrame>
        </Fragment>
    );
};

export default memo(DesignView);
